import sales from '../../../services/sales'
import {EventBus} from '../../../event-bus';
import {router} from '../../../routes'
import Reprocess from './reprocess.vue';
import DetailOrder from './detail-order.vue';

export default {
  data() {
    return {
      searchState: undefined,
      orders: undefined,
      loading: undefined,
      messageError:undefined,
      showModal: false,
      allOrderIds: [],
      contractId: undefined
    }
  },
  mounted: function () {
    this.loadData();
  },
  computed:{
    contract() {
      return this.$store.getters.getContractById(this.$route.params.contractId);
    }

  },
  methods:{
    showDetail(order){
        router.push({name: 'request-detail', params: {orderId: order.orderId}});
    },
    loadData(){
      this.loading = sales.listSalesOrders({statusId: 3, type: 'COMPLETE'}).then((result) => {

        if(result && result.code == 9990){
          this.messageError = result.message;
          return false;
        }
        if (result.orders && result.orders.order.length > 0) {
          this.orders = _.filter(result.orders.order, function(o){
            return o.type == 'PASSAGEM' && o.status.statusId == 3;
          });


          if(this.orders.length){
            this.contractId = this.orders[0].contract;
          }

          this.allOrderIds = _.map(this.orders, function(o){
            return o.orderId;
          });
        }
      }).catch((error) => {
        if(error.data.status && error.data.status.code == 9990){
          this.messageError = error.data.status.message;
          return false;
        }
      });

    }
  },

  components:{
    Reprocess,
    DetailOrder
  },
  beforeDestroy() {
    
    EventBus.$off('setPayment');
  },

}



// WEBPACK FOOTER //
// ./src/pages/account/request/reprocess-orders.js